import React from "react";
import { Link } from "react-router-dom";
import { Edit } from "react-feather";

const GigSalesDataTable = ({ tourId, gigId, sales, userIsEditor }) => {

  const iconSize = 20;

  return (

    <table>
      <thead>
        <tr>
          <th className="left">product</th>
          <th>opening stock</th>
          <th>freebies</th>
          <th>paypal sales</th>
          <th>closing stock</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {
          sales.map(item => {
            const linkPath = `/tour/${tourId}/gig/${gigId}/sales/${item._id}`;
            return (
              <tr>
                <td>{item.productName}</td>
                <td className="center">{item.openingStock}</td>
                <td className="center">{item.numberFreebies}</td>
                <td className="center">{item.numberPaypal}</td>
                <td className="center">{item.closingStock}</td>
                <td>
                  {
                    userIsEditor &&
                    (
                      <Link className="icon-button-link" to={linkPath}><Edit size={iconSize} /></Link>
                    )
                  }
                </td>
              </tr>
            )
          })
        }
      </tbody>
    </table>
    
  )
};

export default GigSalesDataTable;